var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreepipeReplyOfficial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 1523.89 474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill: #22d5f2;      }      .cls-2 {        fill: #050000;      }    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RUNNING_MAN",
    "data-name": "RUNNING MAN"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.79,0c-22.49,0-40.67,18.23-40.67,40.74s18.18,40.65,40.67,40.65,40.67-18.2,40.67-40.65S387.23,0,364.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.58,171.18l50.82-66.9c2.6-3.42,2.81-8.09.54-11.73l-21.59-34.63c-1.9-3.05-5.26-4.9-8.86-4.88l-93.16.65h0l-51.08-.04c-4,0-5.78,5.03-2.66,7.53l14.31,11.54c2.01,1.62,4.4,2.72,6.94,3.2l88.72,16.71-109.75,117.95L5.38,231.1c-5,.71-7.14,6.75-3.69,10.45l14.11,15.13c2.79,2.99,6.72,4.66,10.81,4.6l139.44-2.29c5.16-.08,10.21-1.55,14.62-4.23l33.41-20.35,70.51,55.97c2.78,2.2,4.59,5.4,5.07,8.91l13.42,98.83c.63,4.66,4.61,8.14,9.31,8.14h7.18c5.18,0,9.38-4.19,9.4-9.37l.41-109.68c.02-5.66-1.79-11.17-5.16-15.72l-61.52-82.93,12.87-17.39Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M626.64,311.06l-48.08-86.98h-38.17v86.98h-52.11V66.28h114.5c51.01,0,82.57,33.4,82.57,78.9,0,42.94-27.52,66.42-53.95,72.66l55.42,93.22h-60.19ZM631.78,144.82c0-20.18-15.78-32.66-36.33-32.66h-55.05v66.06h55.05c20.55,0,36.33-12.48,36.33-33.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M724.25,311.06V66.28h173.22v45.87h-121.11v51.38h118.54v45.87h-118.54v55.78h121.11v45.87h-173.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M938.2,311.06V66.28h114.5c53.21,0,82.21,35.96,82.21,78.9s-29.36,78.53-82.21,78.53h-62.39v87.34h-52.11ZM1081.69,145.19c0-20.55-15.78-33.03-36.33-33.03h-55.05v65.69h55.05c20.55,0,36.33-12.48,36.33-32.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1165.35,311.06V66.28h52.48v198.91h103.49v45.87h-155.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1378.2,311.06v-100.19l-93.95-144.59h59.45l60.55,97.98,60.55-97.98h59.09l-93.58,144.59v100.19h-52.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.54,474v-86.23h-30.88v-15.75h79.66v15.75h-30.88v86.23h-17.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M647.4,474v-44.65h-53.05v44.65h-17.89v-101.98h17.89v41.59h53.05v-41.59h17.89v101.98h-17.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.26,474l-22.47-38.07h-17.89v38.07h-17.89v-101.98h44.79c20.19,0,33.49,13,33.49,31.95s-11.93,27.98-24.31,29.97l25.07,40.06h-20.79ZM746.94,403.82c0-9.79-7.34-16.05-17.43-16.05h-24.61v32.41h24.61c10.09,0,17.43-6.42,17.43-16.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.18,474v-101.98h69.87v15.75h-51.98v26.3h50.92v15.75h-50.92v28.44h51.98v15.75h-69.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M871.4,474v-101.98h69.87v15.75h-51.98v26.3h50.92v15.75h-50.92v28.44h51.98v15.75h-69.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M959.63,474v-101.98h44.95c21.4,0,33.17,14.53,33.17,31.95s-11.93,31.8-33.17,31.8h-27.06v38.22h-17.89ZM1019.41,403.97c0-9.79-7.19-16.21-17.28-16.21h-24.62v32.26h24.62c10.09,0,17.28-6.42,17.28-16.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1052.75,474v-101.98h17.89v101.98h-17.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1092.35,474v-101.98h44.95c21.4,0,33.17,14.53,33.17,31.95s-11.93,31.8-33.17,31.8h-27.06v38.22h-17.89ZM1152.13,403.97c0-9.79-7.19-16.21-17.28-16.21h-24.62v32.26h24.62c10.09,0,17.28-6.42,17.28-16.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185.47,474v-101.98h69.87v15.75h-51.98v26.3h50.91v15.75h-50.91v28.44h51.98v15.75h-69.87Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreepipeReplyOfficial);
export default __webpack_public_path__ + "static/media/threepipe-reply-official.a6830c8d7eaeac972c5891f9ef029f87.svg";
export { ForwardRef as ReactComponent };